<!-- 预览PDF -->
<template>
  <div class="pdf-box">
    <PDF ref="pdf" v-for="index in pageTotalNum" :key="index" :src="pdfUrl" :page="index"></PDF>
  </div>
</template>
<script>
import PDF from 'vue-pdf'
export default {
  components:{
    PDF,
  },
  props: {
    url: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      pageTotalNum: 1,
      loaded: false,
      pdfUrl: ''
    }
  },
  created() {
    this.loadPdf()
  },
  methods:{
    loadPdf () {
      // this.pdfUrl = PDF.createLoadingTask(this.url, {withCredentials: true})
      console.log(decodeURIComponent(this.url))
      this.pdfUrl = PDF.createLoadingTask(decodeURIComponent(this.url));
      console.log(this.pdfUrl)
      this.pdfUrl.promise.then(pdf => {
        this.$nextTick(() => {
          this.pageTotalNum = pdf.numPages // pdf总页数
          this.loaded = true
        })
      })
    }
  }
}
</script>
<style>
.pdf-box {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
